import React from 'react';
import { ConfirmEmailTemplate } from './templates/ConfirmEmailTemplate';
import { WelcomeTemplate } from './templates/WelcomeTemplate';
import { ResetPasswordTemplate } from './templates/ResetPasswordTemplate';
import { PasswordChangedTemplate } from './templates/PasswordChangedTemplate';
import { ResendConfirmationTemplate } from './templates/ResendConfirmationTemplate';
import { ActivationReminderTemplate } from './templates/ActivationReminderTemplate';
import { DeletionConfirmationTemplate } from './templates/DeletionConfirmationTemplate';
import { SuspiciousAttemptsTemplate } from './templates/SuspiciousAttemptsTemplate';
import { TempLockoutTemplate } from './templates/TempLockoutTemplate';
import { NewDeviceTemplate } from './templates/NewDeviceTemplate';
import { NewTrustedDeviceTemplate } from './templates/NewTrustedDeviceTemplate';
import { SuspiciousBlockedTemplate } from './templates/SuspiciousBlockedTemplate';
import { ActivitySummaryTemplate } from './templates/ActivitySummaryTemplate';
import { ClaimCreatedDealerTemplate } from './templates/ClaimCreatedDealerTemplate';
import { ClaimCreatedCorporateTemplate } from './templates/ClaimCreatedCorporateTemplate';
import { ClaimApprovedDealerTemplate } from './templates/ClaimApprovedDealerTemplate';
import { ClaimResolvedDealerTemplate } from './templates/ClaimResolvedDealerTemplate';
import { ClaimRejectedDealerTemplate } from './templates/ClaimRejectedDealerTemplate';
import { FactoryIssueReportTemplate } from './templates/FactoryIssueReportTemplate';
interface EmailTemplateProps {
  templateId: string;
}
export function EmailTemplate({
  templateId
}: EmailTemplateProps) {
  const renderTemplate = () => {
    switch (templateId) {
      case 'auth.signup.confirm_email':
        return <ConfirmEmailTemplate data-id="element-18" />;
      case 'auth.signup.welcome':
        return <WelcomeTemplate data-id="element-19" />;
      case 'auth.forgot_password.request':
        return <ResetPasswordTemplate data-id="element-20" />;
      case 'auth.forgot_password.confirmed':
        return <PasswordChangedTemplate data-id="element-21" />;
      case 'auth.signup.resend_confirmation':
        return <ResendConfirmationTemplate data-id="element-22" />;
      case 'auth.signup.activation_reminder':
        return <ActivationReminderTemplate data-id="element-23" />;
      case 'auth.account.deletion_confirmation':
        return <DeletionConfirmationTemplate data-id="element-24" />;
      case 'auth.password.suspicious_attempts':
        return <SuspiciousAttemptsTemplate data-id="element-25" />;
      case 'auth.password.temp_lockout':
        return <TempLockoutTemplate data-id="element-26" />;
      case 'auth.login.new_device':
        return <NewDeviceTemplate data-id="element-27" />;
      case 'auth.login.new_trusted_device':
        return <NewTrustedDeviceTemplate data-id="element-28" />;
      case 'auth.login.suspicious_blocked':
        return <SuspiciousBlockedTemplate data-id="element-29" />;
      case 'auth.login.activity_summary':
        return <ActivitySummaryTemplate data-id="element-30" />;
      case 'claims.dealer.claim_created':
        return <ClaimCreatedDealerTemplate data-id="element-31" />;
      case 'claims.corporate.claim_created_assigned':
        return <ClaimCreatedCorporateTemplate data-id="element-32" />;
      case 'claims.dealer.claim_approved':
        return <ClaimApprovedDealerTemplate data-id="element-33" />;
      case 'claims.dealer.claim_resolved':
        return <ClaimResolvedDealerTemplate data-id="element-34" />;
      case 'claims.dealer.claim_rejected_with_note':
        return <ClaimRejectedDealerTemplate data-id="element-35" />;
      case 'claims.factory.issue_report_created':
        return <FactoryIssueReportTemplate data-id="element-36" />;
      default:
        return <ConfirmEmailTemplate data-id="element-37" />;
    }
  };
  return <div className="bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-38">
      <div className="bg-gray-100 px-4 py-2 border-b border-gray-200" data-id="element-39">
        <p className="text-xs text-gray-600" data-id="element-40">
          Vista previa del email • ID:{' '}
          <span className="font-mono" data-id="element-41">{templateId}</span>
        </p>
      </div>
      <div className="p-8" data-id="element-42">{renderTemplate()}</div>
    </div>;
}